/**
 * @generated SignedSource<<9b0bd777202d5a03b37065a2dd9ad192>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AdjustProductStockInput = {
  clientMutationId?: string | null | undefined;
  delta: number;
  productId: string;
};
export type OpsProductsPageAdjustMutation$variables = {
  input: AdjustProductStockInput;
};
export type OpsProductsPageAdjustMutation$data = {
  readonly adjustProductStock: {
    readonly product: {
      readonly id: string;
      readonly lowStock: boolean;
      readonly quantityOnHand: number;
    } | null | undefined;
    readonly userErrors: ReadonlyArray<{
      readonly message: string;
    }>;
  } | null | undefined;
};
export type OpsProductsPageAdjustMutation = {
  response: OpsProductsPageAdjustMutation$data;
  variables: OpsProductsPageAdjustMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AdjustProductStockPayload",
    "kind": "LinkedField",
    "name": "adjustProductStock",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Product",
        "kind": "LinkedField",
        "name": "product",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "quantityOnHand",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lowStock",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserError",
        "kind": "LinkedField",
        "name": "userErrors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "OpsProductsPageAdjustMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OpsProductsPageAdjustMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7b7d02a8294336590b4d504ad6f78ffb",
    "id": null,
    "metadata": {},
    "name": "OpsProductsPageAdjustMutation",
    "operationKind": "mutation",
    "text": "mutation OpsProductsPageAdjustMutation(\n  $input: AdjustProductStockInput!\n) {\n  adjustProductStock(input: $input) {\n    product {\n      id\n      quantityOnHand\n      lowStock\n    }\n    userErrors {\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8a1417b437144d811e868ec2514af515";

export default node;
